import { RouteConfig } from 'vue-router';
const BASE_PATH = 'views/dataManagement';
const standard: Array<RouteConfig> = [
    {
        path: 'data-manage/standard',
        name: 'standard',
        redirect: { name: 'standardSettings' },
        meta: {
            menuMatch: 'standardSettings',
        },
        component: () => import(`@/${BASE_PATH}/Main.vue`),
        children: [
            {
                path: 'settings',
                name: 'standardSettings',
                component: () => import(`@/${BASE_PATH}/standard/Standard.vue`),
                meta: {
                    index: '4',
                    type:'标准',
                    subPage:'standardSettingsDetail'
                },
            },
            {
                path: 'detail',
                name: 'standardSettingsDetail',
                component: () => import(`@/${BASE_PATH}/standard/StandardDetail.vue`),
                meta: {
                    index: '4',
                    type:'标准',
                    supPage:'standardSettings',
                    noBottom:true
                },
            },
        ],
    },
];
export default standard;